export function splitColumns(items: any[]) {
    return items.reduce(
        (a, c, i, self) => {
            const splitIndex = self.findIndex(
                (x) => x.type && x.type === 'ColumnBreak'
            );
            const temp = [...a];

            if (i < splitIndex) {
                temp[0].push(c);
            } else if (i > splitIndex) {
                temp[1].push(c);
            }

            return temp;
        },
        [[], []]
    );
}

import { IGroupedItems, IMenuItem, IMenuLink } from '.';

export function groupLists(column: IMenuItem[]) {
    const groupedItems: IGroupedItems[] = [];

    column.forEach((item, index) => {
        const itemLink = <IMenuLink>{...item};

        if (item.type && item.type === 'GroupHeader') {
            const newGroup = { ...item, items: [] };
            groupedItems.push(newGroup);
        } else if (groupedItems.length === 0) {
            groupedItems.push({
                caption: 'unknown',
                items: [ itemLink ]
            });
        } else {
            groupedItems[groupedItems.length - 1].items.push(itemLink);
        }
    });

    return groupedItems;
}
